export default __webpack_public_path__ + "static/media/mc2.e523d229.png";